<template>
  <vs-popup id="popup"
            title="UPLOAD SUPPLIER INVOICE"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createInvoiceDocument)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
                <small class="label">File</small>
                <file-uploader
                  v-on:onSetFileName="value => form.url = value"
                  v-on:onClickFileRemove="form.url = null"
                  :file="form.url"
                  :condition="true"
                />
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";

const InventoryRepository = RepositoryFactory.get('inventory')

function initialState(){
  return{
    open:false,
    orderId:null,
    form:{
      url: '',
      name: '',
      type: 'invoice'
    }
  }
}

export default {
  name: "AddSupplierInvoiceFilePopUp",
  data(){
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    async openPopup(id){
      await Object.assign(this.$data, initialState())
      this.$refs.form.reset();
      this.orderId = id
      this.open = true
    },
    async createInvoiceDocument(){
      const vue = this;
      this.$vs.loading()
      try {
        await InventoryRepository.createRawMaterialOrderDocument(this.orderId, this.form)
        this.showSuccessMessage('Raw Material Document Create Successfully')
        await vue.$parent.getSupplierInvoiceDocuments()
        this.open = false
        await vue.$parent.openInvoiceDocument()
      }catch (error){
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style scoped>

</style>
